import Dialog from '../../../../dialogs/dialog';
import { GlobalProvider } from "../../../../../utils/globalprovider.js";
import React from 'react';
import GoToNumber from '../../../../../components/goto/goto.js';

import './commongoto.css';

class CommonGoTo extends Dialog {
  constructor(props) {
    super(props);

    this.state.title = props.title;

    this.state.buttons =
      [
        { type: "text", disabled: false, text: { fr: "Valider", en: "Submit" }, key: "submit" },
        { type: "back", disabled: false },
      ]
    
    this.onQuit = this.onQuit.bind(this);
    this.handleButton = this.handleButton.bind(this);
    this.onChange = this.onChange.bind(this);

    this.gotoRef = React.createRef();

    this.state.goToNumber = "";
  }
  
  onQuit() {
    this.props.onButton({ name: "back" });
  }

  handleButton(buttonkey) {
    console.log("on click", buttonkey)

    switch (buttonkey) {
      case "back":
        this.onQuit();
        break;
      
      case "submit":
        this.props.onButton({ name: "submit", goToNumber: this.state.goToNumber });
        break;
      
      default:
        return;
    }
  }

  onChange(text) {
    this.setState({goToNumber: text});
  }

  render() {
    var maxwidth = (window.innerWidth * 55) / 100;
    if (maxwidth > 300) maxwidth = 300;
    
    var maxheight = (window.innerHeight * 82) / 100;
    if (maxheight > 100) maxheight = 100;
    
    const retour =
      (
        <div style={{ width: maxwidth, height: maxheight }}>
          <div className="divcommongoto">
            <GlobalProvider>
              <GoToNumber ref={this.gotoRef} title={this.props.title} onChange={this.onChange} handleButton={this.handleButton}></GoToNumber>
            </GlobalProvider>
          </div>
        </div>
      )
    
    return super.render(retour);
  }
}

export default CommonGoTo;